<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import FilterBar from '@lib/components/shared/FilterBar.vue'
import BInput from '@lib/components/base/BInput.vue'
import BSelect from '@lib/components/base/BSelect.vue'
import type { TicketsetFilters } from '@/composables/useTicketsetsData'

const props = defineProps<{
    modelValue: TicketsetFilters
    eventOptions?: Array<{ id: string; name: string }>
}>()
const emit = defineEmits<{
    (e: 'update:modelValue', v: TicketsetFilters): void
    (e: 'clear'): void
}>()

const { t } = useI18n()

const activeCount = computed(() => {
    let n = 0
    if (props.modelValue.search) n++
    if (props.modelValue.event) n++
    return n
})

function update<K extends keyof TicketsetFilters>(key: K, value: TicketsetFilters[K]) {
    emit('update:modelValue', { ...props.modelValue, [key]: value })
}
</script>

<template>
    <FilterBar :active-count="activeCount" @clear="$emit('clear')">
        <label class="block">
            <span class="text-xs text-gray-600 mb-1 block">{{ t('ticketsets.filter.search') }}</span>
            <BInput
                :model-value="modelValue.search"
                :placeholder="t('ticketsets.filter.search')"
                @update:model-value="v => update('search', v)"
            />
        </label>
        <label class="block">
            <span class="text-xs text-gray-600 mb-1 block">{{ t('ticketsets.filter.event') }}</span>
            <BSelect
                :model-value="modelValue.event"
                :options="eventOptions ?? []"
                option-label="name"
                option-value="id"
                :placeholder="t('ticketsets.filter.event')"
                :filter="true"
                @update:model-value="v => update('event', v as string | null)"
            />
        </label>
    </FilterBar>
</template>
